import React from "react";
import { Link } from "react-router-dom";

import { useRecoilValueLoadable } from "recoil";
import { asyncGetProject } from "lib/store/project";

import { Symbol } from "@atsent/components";

import { SidebarItem } from "components/atom/SidebarItem";

import "./Sidebar.scss";

export type SidebarProps = {
  cx?: string;
};

const sideMenu = [
  {
    title: "Dashboard",
    isOpen: true,
    submenu: [
      {
        title: "Dashboard",
        link: "",
        hasRoot: true,
      },
      {
        title: "Thread",
        link: "/thread",
        hasRoot: true,
      },
      {
        title: "Aspects",
        link: "/aspects",
        hasRoot: true,
      },
    ],
  },
  {
    title: "데이터 분석",
    link: "/batch",
    hasRoot: true,
  },
  {
    title: "채널 연동",
    link: "/api-connect",
    hasRoot: true,
  },
];

export const Sidebar: React.FC<SidebarProps> = ({ cx = "" }) => {
  const project = useRecoilValueLoadable(asyncGetProject);
  return (
    <aside className={`Sidebar ${cx}`}>
      <div className={"title-logo"}>
        <Link to={"/"}>
          <Symbol />
        </Link>
      </div>
      <div className="project-name">
        <span>{project.contents?.name}</span>
      </div>
      <ul className={"sidebar-wrapper"}>
        {sideMenu.map(({ title, link }) => (
          <SidebarItem key={title} title={title} link={link} />
        ))}
      </ul>
      <div className={"copyright"}>
        사업자등록번호 : 642-87-02235
        <br />
        경기도 성남시 분당구 황새울로 335번길 10, 5층 540호
        <br />
        대표자 : 박헌영
        <span className={"bar"}>|</span>
        전화번호 : 031-709-5323
        <br />
        <br />
        ©onmydev Inc. All rights reserved.
      </div>
    </aside>
  );
};
